__turbopack_context__.v({
  "content": "m-road-to-zero-item-module-scss-module__THSCHq__content",
  "placeholder": "m-road-to-zero-item-module-scss-module__THSCHq__placeholder",
  "reversed": "m-road-to-zero-item-module-scss-module__THSCHq__reversed",
  "section": "m-road-to-zero-item-module-scss-module__THSCHq__section",
  "section-bg-faded-aqua": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-faded-aqua",
  "section-bg-faded-berry": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-faded-berry",
  "section-bg-faded-green": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-faded-green",
  "section-bg-faded-smoke": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-faded-smoke",
  "section-bg-light-aqua": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-light-aqua",
  "section-bg-light-berry": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-light-berry",
  "section-bg-light-green": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-light-green",
  "section-bg-light-smoke": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-light-smoke",
  "section-bg-white": "m-road-to-zero-item-module-scss-module__THSCHq__section-bg-white",
  "wrapper": "m-road-to-zero-item-module-scss-module__THSCHq__wrapper",
});
